/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".identify-toggle[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{margin-bottom:15px}"];
export { styles as styles };
